import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataManager from '../../DataManager';

const FromDateToDateStat = ({ code, caption, maxDays, endpoint, handleSubmit, }) => {
  //const yesterday = DataManager.date.addDays(Date.now(), -1);
  //const fromDateDefault = DataManager.date.addDays(yesterday, -maxDays);
  //const toDateDefault = yesterday; // Set to yesterday
  const today = new Date().toISOString().split('T')[0]; // Convert to 'YYYY-MM-DD' format
  const fromDateDefault = today;
  const toDateDefault = today;

  const [fromDate, setFromDate] = useState(fromDateDefault);
  const [toDate, setToDate] = useState(toDateDefault);
  const [lastChangedDate, setLastChangedDate] = useState(null);
  const [dateRangeError, setDateRangeError] = useState(false);

  useEffect(() => {
    if (!fromDate || !toDate) {
      setDateRangeError(true);
      return;
    }

    const timeDiff = Math.abs(new Date(toDate) - new Date(fromDate));
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays > maxDays) {
      setDateRangeError(true);
    } else {
      setDateRangeError(false);
    }
  }, [fromDate, toDate, maxDays]);

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
    setLastChangedDate('fromDate');
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);
    setLastChangedDate('toDate');
  };

  const doSubmit = (e) => {
    e.preventDefault();

    if (dateRangeError) {
      return;
    }

    const payload = {
      reportCode: code,
      fromDate: fromDate,
      toDate: toDate,
      maxDays: maxDays
    };
    handleSubmit(e, endpoint, payload);
  }

  const errorMessage = dateRangeError === false ? null :
    <h5 className="card-title text-danger">Range date non valido</h5>;

  return (
    <form onSubmit={doSubmit} className="container my-5">
      <div className="card p-3">

        <h5 className="card-title">{caption}</h5>
        <div className="text-muted medium mb-2">
          ( Range massimo: {maxDays} giorni )
        </div>

        {errorMessage}
        <div className="row align-items-end">
          <div className="col-md-4 mb-3">
            <label htmlFor="fromDate" className="form-label">
              Da data:
            </label>
            <input
              type="date"
              className="form-control"
              id="fromDate"
              value={fromDate}
              //max={toDate}
              min="2000-01-01"
              max="2199-12-31"
              onChange={handleFromDateChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label htmlFor="toDate" className="form-label">
              A data:
            </label>
            <input
              type="date"
              className="form-control"
              id="toDate"
              value={toDate}
              min="2000-01-01"
              max="2199-12-31"
              onChange={handleToDateChange}
            />
          </div>
          <div className="col-md-4  mb-3 text-end">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={dateRangeError}
            >
              <FontAwesomeIcon icon="download" />
              Scarica
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FromDateToDateStat;